import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import renderDonateApp from '@newswebsiteapp/shared/react/donations'

controllerLoadedObservableFactory('donations').subscribe(async () => {
  renderDonateApp({
    url: '/api/donations-nmi/donate',
    selectedNonDefaultDonationRecipient_name: null,
  })
})
